import axios from 'axios'
import IUbendaResponse from 'types/IUbendaResponse'

export default class IubendaRequests {
  static async requestTermsAndConditions(): Promise<string> {
    const result = await axios.get<IUbendaResponse>('https://www.iubenda.com/api/terms-and-conditions/50521746')
    return result.data.content
  }

  static async requestPrivacyPolice(): Promise<string> {
    const result = await axios.get<IUbendaResponse>('https://www.iubenda.com/api/privacy-policy/50521746')
    return result.data.content
  }
}
